import React from 'react';
import BaseMeta from './BaseMeta';
import OpenGraphMeta from './OpenGraphMeta';
import TwitterMeta from './TwitterMeta';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const BASE_TITLE = 'Atlassian Marketplace';
const Meta = _ref => {
  let {
    canonicalUrl,
    description,
    image,
    openGraphImage,
    title,
    twitterImage
  } = _ref;
  const GeneratedTitle = title ? "".concat(title, " | ").concat(BASE_TITLE) : BASE_TITLE;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(BaseMeta, {
      canonicalUrl: canonicalUrl,
      description: description,
      title: GeneratedTitle
    }), /*#__PURE__*/_jsx(OpenGraphMeta, {
      canonicalUrl: canonicalUrl,
      description: description,
      image: openGraphImage || image,
      title: GeneratedTitle
    }), /*#__PURE__*/_jsx(TwitterMeta, {
      description: description,
      image: twitterImage || image,
      title: GeneratedTitle
    })]
  });
};
export default Meta;